import HistoricalDelegationInquiry from './historical-delegation-inquiry.vue'
export default HistoricalDelegationInquiry
